import React from 'react';
import { Empty, Spin, Table, Tag } from 'antd';
import { NavLink } from 'react-router-dom';
import { ColumnsType } from 'antd/lib/table';
import { TeamAuditHistory } from '@cbinsights/userv2service/userv2service';
import useShowPagination from 'client/modules/team/hooks/useShowPagination';
import UTCTooltip from 'client/utils/dates';
import { useGetTeamAuditHistory } from '../services/hooks/useGetTeamAuditHistory';

type Props = {
  idTeam: number;
};

const columns: ColumnsType<TeamAuditHistory> = [
  {
    title: 'Date',
    dataIndex: 'ts_change',
    key: 'ts_change',
    render: (ts: string) => <UTCTooltip date={ts} />,
  },
  {
    title: 'Field',
    dataIndex: 'field_name',
    key: 'field_name',
  },
  {
    title: 'Change',
    key: 'change',
    render: (_: unknown, record: TeamAuditHistory) => (
      <span>
        <Tag color="red">{record.old_value}</Tag>→
        <Tag color="green">{record.new_value}</Tag>
      </span>
    ),
  },
  {
    title: 'Initiator',
    key: 'initiator',
    render: (_: unknown, record: TeamAuditHistory) =>
      record.initiator_email ? (
        <NavLink
          to={`/users/${record.id_initiator}`}
          target="_blank"
          rel="noopener noreferrer"
          className="type--link"
        >
          {`${record.initiator_first_name} ${record.initiator_last_name} (${record.initiator_email})`}
        </NavLink>
      ) : (
        record.initiator_first_name
      ),
  },
];

const TeamUpdates = ({ idTeam }: Props) => {
  const { data, isLoading } = useGetTeamAuditHistory({
    enabled: true,
    params: { id: idTeam },
  });

  const auditHistory = data?.audit_history ?? [];

  const showPagination = useShowPagination({
    data: auditHistory,
    config: { pageSize: 25 },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!isLoading && auditHistory.length === 0) {
    return (
      <div className="flex justify-center">
        <Empty />
      </div>
    );
  }

  return (
    <Table
      columns={columns}
      dataSource={auditHistory.map((entry, i) => ({ ...entry, key: i }))}
      pagination={showPagination}
    />
  );
};

export default TeamUpdates;
